{
  "login.meta.title": {
    "translation": ""
  },
  "login.meta.description": {
    "translation": ""
  },
  "login.heading": {
    "translation": ""
  },
  "login.subtitle": {
    "translation": ""
  },
  "login.email.label": {
    "translation": ""
  },
  "login.email.placeholder": {
    "translation": ""
  },
  "login.email.error.required": {
    "translation": ""
  },
  "login.email.error.invalid": {
    "translation": ""
  },
  "login.email.error.nonWork": {
    "translation": ""
  },
  "login.password.label": {
    "translation": ""
  },
  "login.password.placeholder": {
    "translation": ""
  },
  "login.password.show": {
    "translation": ""
  },
  "login.password.hide": {
    "translation": ""
  },
  "login.password.error.required": {
    "translation": ""
  },
  "login.password.error.incorrect": {
    "translation": ""
  },
  "login.submit": {
    "translation": ""
  },
  "login.submitting": {
    "translation": ""
  },
  "login.cta.register": {
    "translation": ""
  },
  "login.cta.existingPartner": {
    "translation": ""
  },
  "login.cta.forgotPassword": {
    "translation": ""
  },
  "login.error.locked": {
    "translation": ""
  },
  "login.error.inactive": {
    "translation": ""
  },
  "login.error.notFound": {
    "translation": ""
  },
  "login.error.invalidCredentials": {
    "translation": ""
  },
  "login.error.networkFailure": {
    "translation": ""
  },
  "login.error.sessionExpired": {
    "translation": ""
  },
  "register.meta.title": {
    "translation": ""
  },
  "register.meta.description": {
    "translation": ""
  },
  "register.heading": {
    "translation": ""
  },
  "register.subtitle": {
    "translation": ""
  },
  "register.markets.label": {
    "translation": ""
  },
  "register.markets.placeholder": {
    "translation": ""
  },
  "register.markets.selected": {
    "translation": ""
  },
  "register.markets.search": {
    "translation": ""
  },
  "register.markets.editLabel": {
    "translation": ""
  },
  "register.markets.apply": {
    "translation": ""
  },
  "register.markets.error.required": {
    "translation": ""
  },
  "register.firstName.label": {
    "translation": ""
  },
  "register.firstName.placeholder": {
    "translation": ""
  },
  "register.firstName.error.required": {
    "translation": ""
  },
  "register.lastName.label": {
    "translation": ""
  },
  "register.lastName.placeholder": {
    "translation": ""
  },
  "register.lastName.error.required": {
    "translation": ""
  },
  "register.email.label": {
    "translation": ""
  },
  "register.email.placeholder": {
    "translation": ""
  },
  "register.email.error.required": {
    "translation": ""
  },
  "register.email.error.invalid": {
    "translation": ""
  },
  "register.email.error.nonWork": {
    "translation": ""
  },
  "register.email.error.duplicate": {
    "translation": ""
  },
  "register.phone.label": {
    "translation": ""
  },
  "register.phone.placeholder": {
    "translation": ""
  },
  "register.phone.helper": {
    "translation": ""
  },
  "register.phone.error.required": {
    "translation": ""
  },
  "register.company.label": {
    "translation": ""
  },
  "register.company.placeholder": {
    "translation": ""
  },
  "register.company.error.required": {
    "translation": ""
  },
  "register.website.label": {
    "translation": ""
  },
  "register.website.placeholder": {
    "translation": ""
  },
  "register.website.error.required": {
    "translation": ""
  },
  "register.website.error.invalid": {
    "translation": ""
  },
  "register.vendors.label": {
    "translation": ""
  },
  "register.vendors.placeholder": {
    "translation": ""
  },
  "register.vendors.options.1_10": {
    "translation": ""
  },
  "register.vendors.options.11_50": {
    "translation": ""
  },
  "register.vendors.options.51_200": {
    "translation": ""
  },
  "register.vendors.options.200plus": {
    "translation": ""
  },
  "register.vendors.error.required": {
    "translation": ""
  },
  "register.pgpKey.label": {
    "translation": ""
  },
  "register.pgpKey.placeholder": {
    "translation": ""
  },
  "register.pgpKey.helper": {
    "translation": ""
  },
  "register.pgpKey.error.required": {
    "translation": ""
  },
  "register.terms.prefix": {
    "translation": ""
  },
  "register.terms.termsLink": {
    "translation": ""
  },
  "register.terms.separator": {
    "translation": ""
  },
  "register.terms.privacyLink": {
    "translation": ""
  },
  "register.terms.error.required": {
    "translation": ""
  },
  "register.submit": {
    "translation": ""
  },
  "register.submitting": {
    "translation": ""
  },
  "register.error.submissionFailed": {
    "translation": ""
  },
  "register.cta.backToLogin": {
    "translation": ""
  },
  "register_confirm.meta.title": {
    "translation": ""
  },
  "register_confirm.meta.description": {
    "translation": ""
  },
  "register_confirm.heading": {
    "translation": ""
  },
  "register_confirm.message": {
    "translation": ""
  },
  "register_confirm.cta.backToLogin": {
    "translation": ""
  },
  "existing_partner.meta.title": {
    "translation": ""
  },
  "existing_partner.meta.description": {
    "translation": ""
  },
  "existing_partner.heading": {
    "translation": ""
  },
  "existing_partner.subtitle": {
    "translation": ""
  },
  "existing_partner.email.label": {
    "translation": ""
  },
  "existing_partner.email.placeholder": {
    "translation": ""
  },
  "existing_partner.email.helper": {
    "translation": ""
  },
  "existing_partner.email.error.required": {
    "translation": ""
  },
  "existing_partner.email.error.invalid": {
    "translation": ""
  },
  "existing_partner.email.error.notFound": {
    "translation": ""
  },
  "existing_partner.email.error.inactive": {
    "translation": ""
  },
  "existing_partner.email.error.alreadySent": {
    "translation": ""
  },
  "existing_partner.submit": {
    "translation": ""
  },
  "existing_partner.submitting": {
    "translation": ""
  },
  "existing_partner.success.sent": {
    "translation": ""
  },
  "existing_partner.error.apiFailure": {
    "translation": ""
  },
  "existing_partner.error.rateLimited": {
    "translation": ""
  },
  "existing_partner.cta.backToLogin": {
    "translation": ""
  },
  "existing_partner.cta.returnToLogin": {
    "translation": ""
  },
  "set_password.meta.title": {
    "translation": ""
  },
  "set_password.meta.description": {
    "translation": ""
  },
  "set_password.heading": {
    "translation": ""
  },
  "set_password.subtitle": {
    "translation": ""
  },
  "set_password.password.label": {
    "translation": ""
  },
  "set_password.password.placeholder": {
    "translation": ""
  },
  "set_password.password.show": {
    "translation": ""
  },
  "set_password.password.hide": {
    "translation": ""
  },
  "set_password.password.error.required": {
    "translation": ""
  },
  "set_password.password.error.tooShort": {
    "translation": ""
  },
  "set_password.password.error.tooLong": {
    "translation": ""
  },
  "set_password.password.error.needsUppercase": {
    "translation": ""
  },
  "set_password.password.error.needsNumber": {
    "translation": ""
  },
  "set_password.password.error.needsSpecial": {
    "translation": ""
  },
  "set_password.password.rules.length": {
    "translation": ""
  },
  "set_password.password.rules.maxLength": {
    "translation": ""
  },
  "set_password.password.rules.uppercase": {
    "translation": ""
  },
  "set_password.password.rules.number": {
    "translation": ""
  },
  "set_password.password.rules.special": {
    "translation": ""
  },
  "set_password.confirmPassword.label": {
    "translation": ""
  },
  "set_password.confirmPassword.placeholder": {
    "translation": ""
  },
  "set_password.confirmPassword.show": {
    "translation": ""
  },
  "set_password.confirmPassword.hide": {
    "translation": ""
  },
  "set_password.confirmPassword.error.required": {
    "translation": ""
  },
  "set_password.confirmPassword.error.mismatch": {
    "translation": ""
  },
  "set_password.submit": {
    "translation": ""
  },
  "set_password.submitting": {
    "translation": ""
  },
  "set_password.error.tokenInvalid": {
    "translation": ""
  },
  "set_password.error.tokenExpired": {
    "translation": ""
  },
  "forgot_password.meta.title": {
    "translation": ""
  },
  "forgot_password.meta.description": {
    "translation": ""
  },
  "forgot_password.heading": {
    "translation": ""
  },
  "forgot_password.subtitle": {
    "translation": ""
  },
  "forgot_password.email.label": {
    "translation": ""
  },
  "forgot_password.email.placeholder": {
    "translation": ""
  },
  "forgot_password.email.error.required": {
    "translation": ""
  },
  "forgot_password.email.error.invalid": {
    "translation": ""
  },
  "forgot_password.email.error.nonWork": {
    "translation": ""
  },
  "forgot_password.submit": {
    "translation": ""
  },
  "forgot_password.submitting": {
    "translation": ""
  },
  "forgot_password.sent.message": {
    "translation": ""
  },
  "forgot_password.sent.resend": {
    "translation": ""
  },
  "forgot_password.sent.cooldown": {
    "translation": ""
  },
  "forgot_password.cta.backToLogin": {
    "translation": ""
  },
  "link_expired.meta.title": {
    "translation": ""
  },
  "link_expired.meta.description": {
    "translation": ""
  },
  "link_expired.heading": {
    "translation": ""
  },
  "link_expired.message": {
    "translation": ""
  },
  "link_expired.resend.submit": {
    "translation": ""
  },
  "link_expired.resend.submitting": {
    "translation": ""
  },
  "link_expired.resend.sent": {
    "translation": ""
  },
  "link_expired.resend.cooldown": {
    "translation": ""
  },
  "link_expired.cta.backToLogin": {
    "translation": ""
  },
  "app_nav.dashboard": {
    "translation": ""
  },
  "app_nav.credentials": {
    "translation": ""
  },
  "app_nav.vendors": {
    "translation": ""
  },
  "app_nav.docs": {
    "translation": ""
  },
  "app_nav.support": {
    "translation": ""
  },
  "app_nav.logout": {
    "translation": ""
  },
  "app_nav.lockedTooltip": {
    "translation": ""
  },
  "app_nav.collapseNav": {
    "translation": ""
  },
  "app_nav.expandNav": {
    "translation": ""
  },
  "pending_dashboard.meta.title": {
    "translation": ""
  },
  "pending_dashboard.meta.description": {
    "translation": ""
  },
  "pending_dashboard.alert.info.heading": {
    "translation": ""
  },
  "pending_dashboard.alert.info.submittedAt": {
    "translation": ""
  },
  "pending_dashboard.alert.neutral.message": {
    "translation": ""
  },
  "pending_dashboard.welcome": {
    "translation": ""
  },
  "pending_dashboard.body": {
    "translation": ""
  },
  "pending_dashboard.cta.checkStatus": {
    "translation": ""
  },
  "pending_dashboard.cta.support": {
    "translation": ""
  },
  "active_dashboard.meta.title": {
    "translation": ""
  },
  "active_dashboard.meta.description": {
    "translation": ""
  },
  "active_dashboard.alert.success": {
    "translation": ""
  },
  "active_dashboard.welcome": {
    "translation": ""
  },
  "active_dashboard.subtitle": {
    "translation": ""
  },
  "active_dashboard.tag": {
    "translation": ""
  },
  "active_dashboard.quickAccess.heading": {
    "translation": ""
  },
  "active_dashboard.quickAccess.open": {
    "translation": ""
  },
  "active_dashboard.quickAccess.credentials.label": {
    "translation": ""
  },
  "active_dashboard.quickAccess.credentials.description": {
    "translation": ""
  },
  "active_dashboard.quickAccess.vendors.label": {
    "translation": ""
  },
  "active_dashboard.quickAccess.vendors.description": {
    "translation": ""
  },
  "active_dashboard.quickAccess.support.label": {
    "translation": ""
  },
  "active_dashboard.quickAccess.support.description": {
    "translation": ""
  },
  "active_dashboard.quickAccess.docs.label": {
    "translation": ""
  },
  "active_dashboard.quickAccess.docs.description": {
    "translation": ""
  },
  "support.meta.title": {
    "translation": ""
  },
  "support.meta.description": {
    "translation": ""
  },
  "support.heading": {
    "translation": ""
  },
  "support.newTicket": {
    "translation": ""
  },
  "support.submitted": {
    "translation": ""
  },
  "support.empty.heading": {
    "translation": ""
  },
  "support.empty.message": {
    "translation": ""
  },
  "support.table.id": {
    "translation": ""
  },
  "support.table.subject": {
    "translation": ""
  },
  "support.table.category": {
    "translation": ""
  },
  "support.table.status": {
    "translation": ""
  },
  "support.table.lastActivity": {
    "translation": ""
  },
  "support.status.open": {
    "translation": ""
  },
  "support.status.in_progress": {
    "translation": ""
  },
  "support.status.closed": {
    "translation": ""
  },
  "support.category.application_status": {
    "translation": ""
  },
  "support.category.technical_question": {
    "translation": ""
  },
  "support.category.other": {
    "translation": ""
  },
  "support.category.credentials": {
    "translation": ""
  },
  "support.category.vendor_onboarding": {
    "translation": ""
  },
  "support.category.orders": {
    "translation": ""
  },
  "support.category.catalog": {
    "translation": ""
  },
  "support.new.heading": {
    "translation": ""
  },
  "support.new.brand.label": {
    "translation": ""
  },
  "support.new.brand.placeholder": {
    "translation": ""
  },
  "support.new.brand.error.required": {
    "translation": ""
  },
  "support.new.relatedVendor.label": {
    "translation": ""
  },
  "support.new.relatedVendor.optional": {
    "translation": ""
  },
  "support.new.subject.label": {
    "translation": ""
  },
  "support.new.subject.placeholder": {
    "translation": ""
  },
  "support.new.subject.error.required": {
    "translation": ""
  },
  "support.new.category.label": {
    "translation": ""
  },
  "support.new.category.placeholder": {
    "translation": ""
  },
  "support.new.category.error.required": {
    "translation": ""
  },
  "support.new.message.label": {
    "translation": ""
  },
  "support.new.message.placeholder": {
    "translation": ""
  },
  "support.new.message.error.required": {
    "translation": ""
  },
  "support.new.message.error.tooShort": {
    "translation": ""
  },
  "support.new.submit": {
    "translation": ""
  },
  "support.new.submitting": {
    "translation": ""
  },
  "support.new.cancel": {
    "translation": ""
  },
  "support.new.submitError": {
    "translation": ""
  },
  "support.new.download": {
    "translation": ""
  },
  "support.new.draft.restored": {
    "translation": ""
  },
  "support.new.draft.discard": {
    "translation": ""
  },
  "support.detail.heading": {
    "translation": ""
  },
  "support.detail.label.status": {
    "translation": ""
  },
  "support.detail.label.id": {
    "translation": ""
  },
  "support.detail.label.brand": {
    "translation": ""
  },
  "support.detail.label.category": {
    "translation": ""
  },
  "support.detail.label.created": {
    "translation": ""
  },
  "support.detail.label.lastActivity": {
    "translation": ""
  },
  "support.detail.label.message": {
    "translation": ""
  },
  "support.detail.label.relatedVendors": {
    "translation": ""
  },
  "support.detail.thread.heading": {
    "translation": ""
  },
  "support.detail.thread.systemRole": {
    "translation": ""
  },
  "support.detail.thread.systemEvent": {
    "translation": ""
  },
  "support.detail.thread.supportRole": {
    "translation": ""
  },
  "support.detail.thread.partnerRole": {
    "translation": ""
  },
  "support.detail.thread.mockReply": {
    "translation": ""
  },
  "support.detail.reply.label": {
    "translation": ""
  },
  "support.detail.reply.placeholder": {
    "translation": ""
  },
  "support.detail.reply.submit": {
    "translation": ""
  },
  "support.detail.reply.sending": {
    "translation": ""
  },
  "support.detail.reply.errorToast": {
    "translation": ""
  },
  "support.detail.closed.note": {
    "translation": ""
  },
  "support.detail.close": {
    "translation": ""
  },
  "vendors.meta.title": {
    "translation": ""
  },
  "vendors.meta.description": {
    "translation": ""
  },
  "vendors.heading": {
    "translation": ""
  },
  "vendors.addVendor": {
    "translation": ""
  },
  "vendors.addSuccess": {
    "translation": ""
  },
  "vendors.statusNote": {
    "translation": ""
  },
  "vendors.pendingSubmissions": {
    "translation": ""
  },
  "vendors.empty": {
    "translation": ""
  },
  "vendors.search.placeholder": {
    "translation": ""
  },
  "vendors.filter.integration": {
    "translation": ""
  },
  "vendors.filter.vendorGroup": {
    "translation": ""
  },
  "vendors.filter.clearAll": {
    "translation": ""
  },
  "vendors.add.heading": {
    "translation": ""
  },
  "vendors.add.close": {
    "translation": ""
  },
  "vendors.add.platform.label": {
    "translation": ""
  },
  "vendors.add.platform.placeholder": {
    "translation": ""
  },
  "vendors.add.country.label": {
    "translation": ""
  },
  "vendors.add.country.placeholder": {
    "translation": ""
  },
  "vendors.add.country.placeholderNoPlatform": {
    "translation": ""
  },
  "vendors.add.vendorCode.label": {
    "translation": ""
  },
  "vendors.add.vendorCode.placeholder": {
    "translation": ""
  },
  "vendors.add.vendorCode.helper": {
    "translation": ""
  },
  "vendors.add.vendorCode.error.required": {
    "translation": ""
  },
  "vendors.add.vendorCode.error.numeric": {
    "translation": ""
  },
  "vendors.add.preview.label": {
    "translation": ""
  },
  "vendors.add.submit": {
    "translation": ""
  },
  "vendors.add.submitting": {
    "translation": ""
  },
  "vendors.add.error.duplicate": {
    "translation": ""
  },
  "vendors.add.error.unavailable": {
    "translation": ""
  },
  "vendors.add.error.submission": {
    "translation": ""
  },
  "vendors.add.cancel": {
    "translation": ""
  },
  "vendors.status.active": {
    "translation": ""
  },
  "vendors.status.inactive": {
    "translation": ""
  },
  "vendors.status.pending": {
    "translation": ""
  },
  "vendors.status.rejected": {
    "translation": ""
  },
  "credentials.meta.title": {
    "translation": ""
  },
  "credentials.meta.description": {
    "translation": ""
  },
  "credentials.heading": {
    "translation": ""
  },
  "credentials.subtitle": {
    "translation": ""
  },
  "credentials.copied": {
    "translation": ""
  },
  "credentials.apiKey.label": {
    "translation": ""
  },
  "credentials.apiKey.tag": {
    "translation": ""
  },
  "credentials.apiKey.reveal": {
    "translation": ""
  },
  "credentials.apiKey.hide": {
    "translation": ""
  },
  "credentials.apiKey.hidesIn": {
    "translation": ""
  },
  "credentials.apiKey.copy": {
    "translation": ""
  },
  "credentials.apiKey.warning": {
    "translation": ""
  },
  "credentials.chainCode.label": {
    "translation": ""
  },
  "credentials.chainCode.copy": {
    "translation": ""
  },
  "credentials.rotation.heading": {
    "translation": ""
  },
  "credentials.rotation.body": {
    "translation": ""
  },
  "credentials.rotation.cta": {
    "translation": ""
  },
  "lang_selector.label": {
    "translation": ""
  },
  "lang_selector.en": {
    "translation": ""
  },
  "lang_selector.ar": {
    "translation": ""
  },
  "lang_selector.tr": {
    "translation": ""
  },
  "error.401.heading": {
    "translation": ""
  },
  "error.401.message": {
    "translation": ""
  },
  "error.403.heading": {
    "translation": ""
  },
  "error.403.message": {
    "translation": ""
  },
  "error.404.heading": {
    "translation": ""
  },
  "error.404.message": {
    "translation": ""
  },
  "error.default.heading": {
    "translation": ""
  },
  "error.default.message": {
    "translation": ""
  },
  "lang_selector.es": {
    "translation": ""
  },
  "lang_selector.es-ES": {
    "translation": ""
  },
  "auth_nav.backToLogin": {
    "translation": ""
  },
  "vendors.add.integration.label": {
    "translation": ""
  },
  "vendors.add.integration.placeholder": {
    "translation": ""
  },
  "vendors.add.noIntegrations": {
    "translation": ""
  },
  "vendors.add.vendorGroup.label": {
    "translation": ""
  },
  "vendors.add.vendorGroup.placeholder": {
    "translation": ""
  },
  "vendors.add.vendorGroup.placeholderNoIntegration": {
    "translation": ""
  },
  "vendors.add.vendorGroup.helper": {
    "translation": ""
  },
  "docs.endpoint.authHeaderDesc": {
    "translation": ""
  },
  "docs.endpoint.bodyDefaultDesc": {
    "translation": ""
  },
  "docs.endpoint.contentTypeDesc": {
    "translation": ""
  },
  "docs.endpoint.deprecated": {
    "translation": ""
  },
  "docs.endpoint.deprecatedInstead": {
    "translation": ""
  },
  "docs.endpoint.deprecatedUse": {
    "translation": ""
  },
  "docs.endpoint.dynamicUrlBody": {
    "translation": ""
  },
  "docs.endpoint.dynamicUrlTitle": {
    "translation": ""
  },
  "docs.endpoint.paramColDesc": {
    "translation": ""
  },
  "docs.endpoint.paramColName": {
    "translation": ""
  },
  "docs.endpoint.pathParams": {
    "translation": ""
  },
  "docs.endpoint.queryParams": {
    "translation": ""
  },
  "docs.endpoint.requestBody": {
    "translation": ""
  },
  "docs.endpoint.requestHeaders": {
    "translation": ""
  },
  "docs.endpoint.required": {
    "translation": ""
  },
  "docs.endpoint.responseSample": {
    "translation": ""
  },
  "docs.endpoint.responses": {
    "translation": ""
  },
  "docs.endpoint.codeTab.curl": {
    "translation": ""
  },
  "docs.endpoint.codeTab.js": {
    "translation": ""
  },
  "docs.endpoint.jsComment.replaceBody": {
    "translation": ""
  },
  "docs.meta.home.title": {
    "translation": ""
  },
  "docs.meta.detail.titleFallback": {
    "translation": ""
  },
  "docs.meta.titleTemplate": {
    "translation": ""
  },
  "docs.heading": {
    "translation": ""
  },
  "docs.menuClose": {
    "translation": ""
  },
  "docs.menuCloseLabel": {
    "translation": ""
  },
  "docs.menuOpen": {
    "translation": ""
  },
  "docs.menuOpenLabel": {
    "translation": ""
  },
  "docs.nav.aria": {
    "translation": ""
  },
  "docs.searchPlaceholder": {
    "translation": ""
  },
  "docs.sectionMeta.endpoints_one": {
    "translation": ""
  },
  "docs.sectionMeta.endpoints_other": {
    "translation": ""
  },
  "docs.sectionMeta.guides_one": {
    "translation": ""
  },
  "docs.sectionMeta.guides_other": {
    "translation": ""
  },
  "docs.subtitle": {
    "translation": ""
  },
  "docs.version": {
    "translation": ""
  },
  "support.new.relatedVendor.placeholder": {
    "translation": ""
  },
  "support.new.relatedVendor.search": {
    "translation": "Buscar proveedores"
  },
  "support.new.relatedVendor.more": {
    "translation": "+{{count}} más"
  },
  "support.new.relatedVendor.noResults": {
    "translation": "Ningún proveedor coincide con tu búsqueda."
  },
  "docs.content.sections.guides.title": {
    "translation": ""
  },
  "docs.content.sections.guides.description": {
    "translation": ""
  },
  "docs.content.sections.middleware.title": {
    "translation": ""
  },
  "docs.content.sections.middleware.description": {
    "translation": ""
  },
  "docs.content.sections.plugin.title": {
    "translation": ""
  },
  "docs.content.sections.plugin.description": {
    "translation": ""
  },
  "docs.content.sections.reference.title": {
    "translation": ""
  },
  "docs.content.sections.reference.description": {
    "translation": ""
  },
  "docs.content.nav.guides.getting-started.title": {
    "translation": ""
  },
  "docs.content.nav.guides.access-integration.title": {
    "translation": ""
  },
  "docs.content.nav.middleware.authentication.token.title": {
    "translation": ""
  },
  "docs.content.nav.middleware.orders.create.title": {
    "translation": ""
  },
  "docs.content.nav.middleware.orders.update-status.title": {
    "translation": ""
  },
  "docs.content.nav.middleware.orders.get.title": {
    "translation": ""
  },
  "docs.content.nav.middleware.vendors.availability.title": {
    "translation": ""
  },
  "docs.content.nav.middleware.vendors.info.title": {
    "translation": ""
  },
  "docs.content.nav.middleware.catalog.import.title": {
    "translation": ""
  },
  "docs.content.nav.middleware.catalog.item-availability.title": {
    "translation": ""
  },
  "docs.content.nav.middleware.reports.order-reporting.title": {
    "translation": ""
  },
  "docs.content.nav.middleware.orders.create-legacy.title": {
    "translation": ""
  },
  "docs.content.nav.plugin.orders.dispatch.title": {
    "translation": ""
  },
  "docs.content.nav.plugin.orders.update-status.title": {
    "translation": ""
  },
  "docs.content.nav.plugin.catalog.menu-import.title": {
    "translation": ""
  },
  "docs.content.nav.plugin.catalog.import-callback.title": {
    "translation": ""
  },
  "docs.content.nav.reference.order-management.title": {
    "translation": ""
  },
  "docs.content.nav.reference.catalog-management.title": {
    "translation": ""
  },
  "docs.content.nav.reference.store-management.title": {
    "translation": ""
  },
  "docs.content.nav.reference.order-report-service.title": {
    "translation": ""
  },
  "docs.content.nav.reference.terminology.title": {
    "translation": ""
  },
  "docs.content.nav.reference.faq.title": {
    "translation": ""
  },
  "docs.content.nav.reference.post-production.title": {
    "translation": ""
  },
  "docs.content.response.400.label": {
    "translation": ""
  },
  "docs.content.response.400.description": {
    "translation": ""
  },
  "docs.content.response.401.label": {
    "translation": ""
  },
  "docs.content.response.401.description": {
    "translation": ""
  },
  "docs.content.response.500.label": {
    "translation": ""
  },
  "docs.content.response.500.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.authentication.token.title": {
    "translation": ""
  },
  "docs.content.ep.middleware.authentication.token.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.authentication.token.body": {
    "translation": ""
  },
  "docs.content.ep.middleware.authentication.token.r200.label": {
    "translation": ""
  },
  "docs.content.ep.middleware.authentication.token.r200.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.create.title": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.create.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.create.body": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.create.r201.label": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.create.r201.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.update-status.title": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.update-status.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.update-status.body": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.update-status.param.orderId": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.update-status.r200.label": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.update-status.r200.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.get.title": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.get.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.get.param.orderId": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.get.query.include": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.get.r200.label": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.get.r200.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.create-legacy.title": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.create-legacy.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.create-legacy.r201.label": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.create-legacy.r201.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.availability.title": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.availability.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.availability.body": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.availability.param.vendorId": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.availability.r200.label": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.availability.r200.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.info.title": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.info.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.info.param.vendorId": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.info.r200.label": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.info.r200.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.import.title": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.import.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.import.body": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.import.r202.label": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.import.r202.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.item-availability.title": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.item-availability.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.item-availability.body": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.item-availability.param.itemId": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.item-availability.r200.label": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.item-availability.r200.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.reports.order-reporting.title": {
    "translation": ""
  },
  "docs.content.ep.middleware.reports.order-reporting.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.reports.order-reporting.query.from": {
    "translation": ""
  },
  "docs.content.ep.middleware.reports.order-reporting.query.to": {
    "translation": ""
  },
  "docs.content.ep.middleware.reports.order-reporting.query.vendorId": {
    "translation": ""
  },
  "docs.content.ep.middleware.reports.order-reporting.r200.label": {
    "translation": ""
  },
  "docs.content.ep.middleware.reports.order-reporting.r200.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.dispatch.title": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.dispatch.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.dispatch.body": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.dispatch.r200.label": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.dispatch.r200.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.dispatch.r500.label": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.dispatch.r500.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.update-status.title": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.update-status.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.update-status.body": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.update-status.r200.label": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.update-status.r200.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.update-status.r500.label": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.update-status.r500.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.menu-import.title": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.menu-import.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.menu-import.r200.label": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.menu-import.r200.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.menu-import.r500.label": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.menu-import.r500.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.import-callback.title": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.import-callback.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.import-callback.body": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.import-callback.param.catalogImportCallback": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.import-callback.r200.label": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.import-callback.r200.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.import-callback.r500.label": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.import-callback.r500.description": {
    "translation": ""
  },
  "docs.content.guide.getting-started.title": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b0.text": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b1.text": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b2.i0": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b2.i1": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b3.text": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b4.text": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i0.title": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i0.body": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i1.title": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i1.body": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i2.title": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i2.body": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i3.title": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i3.body": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i4.title": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i4.body": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i5.title": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i5.body": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i6.title": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i6.body": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i7.title": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i7.body": {
    "translation": ""
  },
  "docs.content.guide.access-integration.title": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b0.text": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b1.text": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b2.i0.title": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b2.i0.body": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b2.i1.title": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b2.i1.body": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b2.i2.title": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b2.i2.body": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b2.i3.title": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b2.i3.body": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b2.i4.title": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b2.i4.body": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b3.text": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b4.text": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b5.text": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b6.i0.term": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b6.i0.def": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b6.i1.term": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b6.i1.def": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b6.i2.term": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b6.i2.def": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b7.text": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b8.i0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b8.i1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b8.i2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b9.text": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b10.text": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.h0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.h1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.h2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r0.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r0.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r0.c2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r1.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r1.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r1.c2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r2.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r2.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r2.c2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r3.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r3.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r3.c2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r4.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r4.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r4.c2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r5.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r5.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r5.c2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r6.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r6.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r6.c2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r7.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r7.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r7.c2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r8.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r8.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r8.c2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r9.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r9.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r9.c2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b12.text": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b13.text": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.h0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.h1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.r0.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.r0.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.r1.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.r1.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.r2.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.r2.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.r3.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.r3.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.r4.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.r4.c1": {
    "translation": ""
  },
  "docs.content.guide.order-management.title": {
    "translation": ""
  },
  "docs.content.guide.order-management.b0.text": {
    "translation": ""
  },
  "docs.content.guide.order-management.b1.text": {
    "translation": ""
  },
  "docs.content.guide.order-management.b2.text": {
    "translation": ""
  },
  "docs.content.guide.order-management.b3.i0.body": {
    "translation": ""
  },
  "docs.content.guide.order-management.b3.i1.body": {
    "translation": ""
  },
  "docs.content.guide.order-management.b3.i2.body": {
    "translation": ""
  },
  "docs.content.guide.order-management.b3.i3.body": {
    "translation": ""
  },
  "docs.content.guide.order-management.b3.i4.body": {
    "translation": ""
  },
  "docs.content.guide.order-management.b4.text": {
    "translation": ""
  },
  "docs.content.guide.order-management.b5.text": {
    "translation": ""
  },
  "docs.content.guide.order-management.b6.i0.body": {
    "translation": ""
  },
  "docs.content.guide.order-management.b6.i1.body": {
    "translation": ""
  },
  "docs.content.guide.order-management.b6.i2.body": {
    "translation": ""
  },
  "docs.content.guide.order-management.b6.i3.body": {
    "translation": ""
  },
  "docs.content.guide.order-management.b7.text": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.h0": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.h1": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.h2": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r0.c0": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r0.c1": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r0.c2": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r1.c0": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r1.c1": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r1.c2": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r2.c0": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r2.c1": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r2.c2": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r3.c0": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r3.c1": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r3.c2": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.title": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b0.text": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b1.text": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b2.i0.title": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b2.i0.body": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b2.i1.title": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b2.i1.body": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b2.i2.title": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b2.i2.body": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b2.i3.title": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b2.i3.body": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b2.i4.title": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b2.i4.body": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b3.text": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b4.text": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b5.text": {
    "translation": ""
  },
  "docs.content.guide.store-management.title": {
    "translation": ""
  },
  "docs.content.guide.store-management.b0.text": {
    "translation": ""
  },
  "docs.content.guide.store-management.b1.i0.term": {
    "translation": ""
  },
  "docs.content.guide.store-management.b1.i0.def": {
    "translation": ""
  },
  "docs.content.guide.store-management.b1.i1.term": {
    "translation": ""
  },
  "docs.content.guide.store-management.b1.i1.def": {
    "translation": ""
  },
  "docs.content.guide.order-report-service.title": {
    "translation": ""
  },
  "docs.content.guide.order-report-service.b0.text": {
    "translation": ""
  },
  "docs.content.guide.order-report-service.b1.i0.term": {
    "translation": ""
  },
  "docs.content.guide.order-report-service.b1.i0.def": {
    "translation": ""
  },
  "docs.content.guide.order-report-service.b1.i1.term": {
    "translation": ""
  },
  "docs.content.guide.order-report-service.b1.i1.def": {
    "translation": ""
  },
  "docs.content.guide.order-report-service.b1.i2.term": {
    "translation": ""
  },
  "docs.content.guide.order-report-service.b1.i2.def": {
    "translation": ""
  },
  "docs.content.guide.terminology.title": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i0.term": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i0.def": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i1.term": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i1.def": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i2.term": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i2.def": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i3.term": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i3.def": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i4.term": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i4.def": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i5.term": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i5.def": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i6.term": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i6.def": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i7.term": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i7.def": {
    "translation": ""
  },
  "docs.content.guide.faq.title": {
    "translation": ""
  },
  "docs.content.guide.faq.b0.text": {
    "translation": ""
  },
  "docs.content.guide.faq.b1.text": {
    "translation": ""
  },
  "docs.content.guide.faq.b2.text": {
    "translation": ""
  },
  "docs.content.guide.faq.b3.text": {
    "translation": ""
  },
  "docs.content.guide.faq.b4.text": {
    "translation": ""
  },
  "docs.content.guide.faq.b5.text": {
    "translation": ""
  },
  "docs.content.guide.faq.b6.text": {
    "translation": ""
  },
  "docs.content.guide.faq.b7.text": {
    "translation": ""
  },
  "docs.content.guide.faq.b8.text": {
    "translation": ""
  },
  "docs.content.guide.faq.b9.text": {
    "translation": ""
  },
  "docs.content.guide.post-production.title": {
    "translation": ""
  },
  "docs.content.guide.post-production.b0.text": {
    "translation": ""
  },
  "docs.content.guide.post-production.b1.i0.body": {
    "translation": ""
  },
  "docs.content.guide.post-production.b1.i1.body": {
    "translation": ""
  },
  "docs.content.guide.post-production.b1.i2.body": {
    "translation": ""
  },
  "docs.content.guide.post-production.b1.i3.body": {
    "translation": ""
  },
  "docs.content.guide.post-production.b2.text": {
    "translation": ""
  },
  "docs.content.guide.post-production.b3.i0": {
    "translation": ""
  },
  "docs.content.guide.post-production.b3.i1": {
    "translation": ""
  },
  "docs.content.guide.post-production.b3.i2": {
    "translation": ""
  },
  "docs.content.guide.post-production.b3.i3": {
    "translation": ""
  }
}
